import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function PlasterCasting() {
  useEffect(() => {
    document.title =
      "Plaster Casting, Splinting and Follow-up Care | Viksha Health Care";
    const newMetaDescription =
      "Plaster casting and splinting at Viksha Health Care for fractures and injuries. Learn about immobilization, cast care, and follow-up visits.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>
        Plaster Casting, Splinting and Follow-up Care
      </h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Plaster-Casting-Splinting-and-Follow-up-Care.avif" />
        </div>
        <div className="textareaofser">
          <h1>Plaster Casting, Splinting and Follow-up Care</h1>

          <p>
            Plaster casting and splinting are commonly used to support and
            protect bones and soft tissues after fractures, sprains, or other
            injuries. Proper immobilization allows the injured area to heal
            safely while reducing pain and preventing further damage.
          </p>

          <p>
            These methods help maintain correct alignment of bones and limit
            movement of injured tissues, creating the right environment for
            healing.
          </p>

          <h5>When Is Casting or Splinting Needed?</h5>
          <ul>
            <li>Bone fractures</li>
            <li>Severe sprains and ligament injuries</li>
            <li>Tendon or soft tissue injuries</li>
            <li>Post-procedure or post-surgery support</li>
          </ul>

          <h5>Plaster Casts</h5>
          <p>
            A plaster cast fully surrounds the injured area to keep it stable.
            It is commonly used for fractures that require firm support for
            proper healing. Casts are carefully molded to ensure comfort while
            maintaining correct bone alignment.
          </p>

          <h5>Splints</h5>
          <p>
            Splints provide support without completely enclosing the limb. They
            are often used in the early stages of injury when swelling is
            expected or for less severe injuries that need partial
            immobilization.
          </p>

          <h5>Benefits of Proper Immobilization</h5>
          <ul>
            <li>Helps bones heal in correct alignment</li>
            <li>Reduces pain by limiting movement</li>
            <li>Prevents further injury to the affected area</li>
            <li>Supports soft tissue recovery</li>
          </ul>

          <h5>Care While Wearing a Cast or Splint</h5>
          <ul>
            <li>Keep the cast or splint clean and dry</li>
            <li>Avoid inserting objects inside to scratch the skin</li>
            <li>Elevate the injured limb to reduce swelling</li>
            <li>Move unaffected joints gently to maintain circulation</li>
            <li>Follow weight-bearing restrictions if advised</li>
          </ul>

          <h5>Follow-up Care Is Important</h5>
          <p>
            Regular follow-up visits help monitor healing progress. The cast or
            splint may be adjusted, replaced, or removed depending on recovery.
            Follow-up assessments ensure proper bone alignment and prevent
            complications.
          </p>

          <h5>Possible Temporary Discomforts</h5>
          <p>
            Mild itching, stiffness, or a feeling of heaviness can occur while
            wearing a cast or splint. These are usually temporary, but any
            severe or worsening symptoms should be reported.
          </p>

          <h5>Signs You Should Report Immediately</h5>
          <ul>
            <li>Increasing pain or tightness inside the cast</li>
            <li>Numbness, tingling, or loss of movement</li>
            <li>Swelling of fingers or toes</li>
            <li>Bad odor or discharge from inside the cast</li>
            <li>Cracks or damage to the cast or splint</li>
          </ul>

          <h5>After Cast or Splint Removal</h5>
          <p>
            Once the cast or splint is removed, the limb may feel stiff or weak.
            Guided exercises and physiotherapy may be recommended to restore
            strength, flexibility, and normal function.
          </p>

          <h5>Returning to Daily Activities</h5>
          <p>
            Resuming normal activities should be gradual. Your doctor will guide
            you on when it is safe to bear weight, return to work, or resume
            sports.
          </p>

          <p>
            Proper casting, splinting, and follow-up care play a vital role in
            safe and effective healing after injuries, helping you return to
            normal activities as soon as possible.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(PlasterCasting);
